import { render } from "./WidgetBhagLinkanzeige.vue?vue&type=template&id=65528066&scoped=true&ts=true"
import script from "./WidgetBhagLinkanzeige.vue?vue&type=script&lang=ts"
export * from "./WidgetBhagLinkanzeige.vue?vue&type=script&lang=ts"

import "./WidgetBhagLinkanzeige.vue?vue&type=style&index=0&id=65528066&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65528066"]])

export default __exports__